/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tab_CakesInputs */

const en_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bakery Treats`)
};

const ar_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حلويات المخبز`)
};

const de_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bäckerei-Leckereien`)
};

const es_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delicias de la pastelería`)
};

const fr_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Délices de la boulangerie`)
};

const it_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delizie della pasticceria`)
};

const ja_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベーカリーのスイーツ`)
};

const ko_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`베이커리 디저트`)
};

const pt_br_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delícias da Padaria`)
};

const ru_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лакомства из пекарни`)
};

const th_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขนมจากร้านเบเกอรี`)
};

const tr_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fırın Lezzetleri`)
};

const zh_cn_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`烘焙坊甜点`)
};

const zh_tw_shop_tab_cakes = /** @type {(inputs: Shop_Tab_CakesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`烘焙坊甜點`)
};

/**
* | output |
* | --- |
* | "Bakery Treats" |
*
* @param {Shop_Tab_CakesInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const shop_tab_cakes = /** @type {((inputs?: Shop_Tab_CakesInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tab_CakesInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shop_tab_cakes(inputs)
	if (locale === "ar") return ar_shop_tab_cakes(inputs)
	if (locale === "de") return de_shop_tab_cakes(inputs)
	if (locale === "es") return es_shop_tab_cakes(inputs)
	if (locale === "fr") return fr_shop_tab_cakes(inputs)
	if (locale === "it") return it_shop_tab_cakes(inputs)
	if (locale === "ja") return ja_shop_tab_cakes(inputs)
	if (locale === "ko") return ko_shop_tab_cakes(inputs)
	if (locale === "pt_br") return pt_br_shop_tab_cakes(inputs)
	if (locale === "ru") return ru_shop_tab_cakes(inputs)
	if (locale === "th") return th_shop_tab_cakes(inputs)
	if (locale === "tr") return tr_shop_tab_cakes(inputs)
	if (locale === "zh_cn") return zh_cn_shop_tab_cakes(inputs)
	return zh_tw_shop_tab_cakes(inputs)
});